import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoutes = ({ isAdmin, children }) => {
  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default AdminRoutes;
